import React from 'react';
import PropTypes from 'prop-types';
import {_truncateDomainName} from "../../common/helpers/HelperFunc";
import Label from "../../common/primitives/Label";
import SelectPrice from "../../common/primitives/SelectPrice";
import Price, {ConvertToEUR} from "../../common/primitives/Price";

import helpers from "../../common/scss/helpers/_helpers.scss";
import buttons from "../../common/primitives/Button.scss";
import removeImg from './img/remove.png';
import styles from "./CartLines.scss";
import HelperGoogleAnalytics from "../../common/helpers/HelperGoogleAnalytics";
import HelperGoogleAnalytics4 from "../../common/helpers/HelperGoogleAnalytics4";
import LoadingRow from "../../common/primitives/LoadingRow";
import {__t} from '../../common/lang/text-resource';

const CartLineDomainTransfer = ({data, taxonomy, removeService, changeServiceTerm, showAsPage}) => {
	const {
		id,
		serviceName,
		serviceId,
		priceData,
		servicePriceId,
		discountPriceList,
		discountPromo,
		discountTerm,
		isCyrillic,
		domainTLD,
		isNewService,
		isRenewService,
		canDelete,
		loading,
		currency,
		term,
		priceOrig,
		priceTopOrig,
	} = data;

	if (loading) {
		return (
		  <section className={showAsPage ? styles.asPage : ''}>
			  <div
				data-layout={`row gutter-none start ${!showAsPage ? 'margin-bottom--xs padding-bottom--xxs' : ''}`}>
				  <div data-layout='col 12 text-center'>
					  <div className={styles.loadingContainer}>
						  <LoadingRow/>
					  </div>
				  </div>
			  </div>
		  </section>
		)
	}
	return (
	  <section className={showAsPage ? styles.asPage : ''}>
		  <div data-layout={`row gutter-none start ${!showAsPage ? 'margin-bottom--xs padding-bottom--xxs' : ''}`}>
			  <div
				className={styles.removeContainer}
				data-layout={`padding-top--xxs ${!showAsPage ? 'padding-left--xs col 1' : ''}`}>
				  {
					canDelete === true &&
					<button data-layout={!showAsPage ? 'margin-left--xxs' : ''}
							className={`${buttons.buttonImage} ${styles.removeButton}`}
							onClick={() => removeService(id, serviceId, serviceName)}>
						<img src={removeImg} alt={__t("Remove")}/>
					</button>
				  }
			  </div>
			  <div data-layout={`col 11 text-left padding-left--xs ${showAsPage ? '5@md' : ''}`}>
				  <Label
					htmlFor={id}
					text={_truncateDomainName(serviceName, domainTLD, 24)}
					title={serviceName}
					className={`${helpers.orderServiceName} ${!showAsPage ? styles.asPageServiceName : ''}`}/>
			  </div>
			  <div data-layout={`col 1 ${showAsPage ? 'hide@md' : ''}`}/>

			  <div data-layout={`col 11 margin-top--xs padding-left--xs ${showAsPage ? '6@md' : ''}`}>

				  {
					  showAsPage === true ?
						<SelectPrice
						  name={id}
						  newPriceCol="price"
						  valueCol="priceId"
						  labelCol="term"
						  options={priceData}
						  oldPriceCol="oldPrice"
						  currencyCol="currency"
						  selected={servicePriceId}
						  onChange={changeServiceTerm}
						  onMenuOpen={() => {
							  HelperGoogleAnalytics.TrackServicePriceSelectorOpen(taxonomy, isNewService);
							  HelperGoogleAnalytics4.TrackServicePriceSelectorOpen(taxonomy, isNewService);
						  }}/>
						:
						<table className={styles.selectedPriceContainer}>
							<tbody>
							<tr>
								<td>{term}</td>
								<td className={styles.oldPrice}>
									{
										priceTopOrig !== priceOrig ? priceTopOrig : null
									}
									{SHVO.showEuroPrices && <>
										<br/>
										{
											priceTopOrig !== priceOrig ? ConvertToEUR(priceTopOrig) : null
										}
									</>}
								</td>
								<td>
									<Price
									  currency={currency}
									  value={priceOrig}
									  currencyClass={styles.currency}/>
									{SHVO.showEuroPrices && <>
										<br/>
										<Price
										  currency={'EUR'}
										  value={ConvertToEUR(priceOrig)}
										  currencyClass={styles.currency}/>
									</>}
								</td>
								<td data-layout='padding-right--md'>&nbsp;</td>
							</tr>
							</tbody>
						</table>
				  }

			  </div>
		  </div>
		  <div data-layout="row gutter-none start" className={styles.discountsWrapper}>
			  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
			  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
			  {/*Редове с отстъпки начало*/}
			  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
			  <div className={styles.rightAtTabPage} data-layout={`col 12 ${showAsPage ? '6@md' : ''}`}>

				  {
					  (discountPriceList > 0 && discountPromo < 100) ?
						<div data-layout="row gutter-none middle">
							<div data-layout={`col 1 ${showAsPage ? 'hide@md' : ''}`}/>
							<div
							  data-layout="col 11 margin-top--xs  padding-left--xs text-left"
							  className={helpers.orderServiceDiscount}>
								{__t('–-discountPriceList%-допълнителна-партньорска-отсb37a22', {discountPriceList: discountPriceList})}
							</div>
						</div>
						: ''
				  }

				  {
					  (discountPromo > 0) ?
						<div data-layout="row gutter-none middle">
							<div data-layout={`col 1 ${showAsPage ? 'hide@md' : ''}`}/>
							<div
							  data-layout="col 11 margin-top--xs  padding-left--xs text-left"
							  className={helpers.orderServiceDiscount}>
								{__t('–:discountPromo% отстъпка от промокод', {discountPromo: discountPromo})}
							</div>
						</div>
						: ''
				  }

				  {
					  (discountTerm > 0 && discountPromo < 100) ?
						<div data-layout="row gutter-none middle">
							<div data-layout={`col 1 ${showAsPage ? 'hide@md' : ''}`}/>
							<div
							  data-layout="col 11 margin-top--xs  padding-left--xs text-left"
							  className={helpers.orderServiceDiscount}>
								{isRenewService ? __t('–:discountTerm% промоционална отстъпка', {discountTerm: discountTerm}) : __t('–:discountTerm% отстъпка за нова услуга', {discountTerm: discountTerm})}
							</div>
						</div>
						: ''
				  }
				  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
				  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
				  {/*Редове с отстъпки край*/}
				  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
				  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
			  </div>
			  {
				  showAsPage ? <div className={styles.removeContainer} data-layout="first@md"/> : ''
			  }
			  <div data-layout={`col 12 ${showAsPage ? '5@md first@md' : ''}`}>
				  <div data-layout="row gutter-none middle margin-top--xxs">
					  <div data-layout={`col 1 ${showAsPage ? 'hide@md' : ''}`}/>
					  <div data-layout="col 11 margin-top--xs  padding-left--xs text-left">
						  {__t('Трансфер и подновяване на домейн')}
					  </div>
				  </div>
			  </div>
		  </div>

	  </section>
	);

};
CartLineDomainTransfer.propTypes = {
	data: PropTypes.shape({
		id: PropTypes.string.isRequired,
		serviceId: PropTypes.string.isRequired,
		serviceName: PropTypes.string.isRequired,
		serviceType: PropTypes.string.isRequired,
		discountPriceList: PropTypes.number,
		discountPromo: PropTypes.number,
		discountTerm: PropTypes.number,
		isCyrillic: PropTypes.bool,
		isNewService: PropTypes.bool,
		isRenewService: PropTypes.bool,
		canDelete: PropTypes.bool,
		domainTLD: PropTypes.string,
		servicePriceId: PropTypes.string,
		priceData: PropTypes.arrayOf(
		  PropTypes.shape({
			  currency: PropTypes.string,
			  oldPrice: PropTypes.string,
			  price: PropTypes.string,
			  priceId: PropTypes.string,
			  term: PropTypes.string,
		  })
		)
	}),
	taxonomy: PropTypes.object,
	removeService: PropTypes.func.isRequired,
	changeServiceTerm: PropTypes.func.isRequired,
	showAsPage: PropTypes.bool
};

export default CartLineDomainTransfer;